import React, { useEffect, useState } from "react";
import { Grid, Stack, Box, Typography } from "@mui/material";
import moment from "moment";
import momentkh from "@thyrith/momentkh";
import { useQuery } from "@apollo/client";
import { GET_CASH_OUT_DETAIL } from "../../Schema/Report";
import { GET_CUSTOMER_INSTALLMENT_BY_DAY } from "../../Schema/Installment";
import {
  getKhmerNumber,
  getKhmerMonth,
  currencyFormat,
} from "../../Function/GetKhmerNumber";
import wingdingImage from "../../Assets/tacteing-header.PNG";
import logoCompany from "../../Assets/logo.svg";

export default function CashOutReport({ dateSelected }) {
  const [khmerDateString, setKhmerDateString] = useState(
    momentkh.format(
      momentkh.fromDate(new Date()),
      "ថ្ងៃW dN ខែm ឆ្នាំa e ព.ស b",
    ),
  );
  useEffect(() => {
    setKhmerDateString(
      momentkh.format(
        momentkh.fromDate(new Date(dateSelected)),
        "ថ្ងៃW dN ខែm ឆ្នាំa e ព.ស b",
      ),
    );
  }, [dateSelected]);
  const [tableData, setTableData] = useState([]);

  const { data } = useQuery(GET_CASH_OUT_DETAIL, {
    variables: {
      year: moment(dateSelected)?.format("YYYY"),
    },
    onCompleted: ({ getCashOutDetail }) => {
      setTableData(getCashOutDetail);
    },
    onError: (error) => {
      console.log(error.message);
    },
  });

  return (
    <div className="setup-company-container">
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <Box className="logo-container">
            <img src={logoCompany} className="logo-company" />
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Stack direction="row" justifyContent="center">
            <Box>
              <div className="summary-center-kh">ព្រះរាជាណាចក្រកម្ពុជា</div>
              <div className="summary-center-kh">ជាតិ សាសនា ព្រះមហាក្សត្រ</div>
              <div className="tackteng-font">
                <img
                  alt="Image"
                  src={wingdingImage}
                  className="image-tackteng"
                />
              </div>
            </Box>
          </Stack>
          <Box className="summary-center-kh" sx={{ marginTop: "60px" }}>
            របាយការណ៍បញ្ចេញសាច់ប្រាក់ប្រចាំឆ្នាំ{" "}
            {getKhmerNumber(moment(dateSelected)?.format("YYYY"))}
          </Box>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{ display: "flex", justifyContent: "right", marginTop: "100px" }}
        >
          <Stack direction="row" spacing={1}>
            <Typography className="number-title-customerbyday">លេខ៖</Typography>
            <Typography className="number-item-customerbyday">
              ...........................
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      <div className="company-table-container">
        <table className="company-table">
          <tr style={{ backgroundColor: "#eaeefa" }}>
            <th rowSpan={2} style={{ width: "5%" }}>
              ល.រ
            </th>
            <th rowSpan={2} style={{ width: "20%" }}>
              កាលបរិច្ឆេទ
            </th>
            <th rowSpan={2} style={{ width: "30%" }}>
              អតិថិជន
            </th>
            <th rowSpan={2} style={{ width: "15%" }}>
              បញ្ចេញសរុប
            </th>
            <th colSpan={3}>ប្រភេទបញ្ចេញកម្ចី</th>
          </tr>
          <tr style={{ backgroundColor: "#eaeefa" }}>
            <th style={{ width: "10%" }}>បង់រំលស់</th>
            <th style={{ width: "10%" }}>កម្ចី</th>
            <th style={{ width: "10%" }}>បញ្ចាំ</th>
          </tr>

          <tr style={{ backgroundColor: "#eaeefa", color: "red" }}>
            <th colSpan={3}></th>
            <th>{currencyFormat(tableData?.total_amount)}</th>
            <th>{currencyFormat(tableData?.total_installments_amount)}</th>
            <th>{currencyFormat(tableData?.total_bussiness_loan_amount)}</th>
            <th>{currencyFormat(tableData?.total_pawn_amount)}</th>
          </tr>

          {tableData?.details_cash_out?.map((row, index) => (
            <tr key={index}>
              <td>{getKhmerNumber(index + 1)}</td>
              <td>
                {getKhmerNumber(moment(row?.loan_date)?.format("DD-MM-YYYY"))}
              </td>
              <td style={{ textAlign: "left" }}>
                {row?.first_name + " " + row?.last_name}
              </td>
              <td>{currencyFormat(row?.total_amount)}</td>
              <td>
                {currencyFormat(
                  row?.amount_and_type
                    ?.filter((e) => e?.type_of_loan === "Installments")
                    ?.reduce((sum, item) => sum + item.loan_amount, 0),
                )}
              </td>
              <td>
                {currencyFormat(
                  row?.amount_and_type
                    ?.filter((e) => e?.type_of_loan === "Loan")
                    ?.reduce((sum, item) => sum + item.loan_amount, 0),
                )}
              </td>

              <td>
                {currencyFormat(
                  row?.amount_and_type
                    ?.filter((e) => e?.type_of_loan === "Pawn")
                    ?.reduce((sum, item) => sum + item.loan_amount, 0),
                )}
              </td>

              {/* {row?.amount_and_type?.map((e) => {
                return (
                  <>
                    <td>{e?.type_of_loan === "Loan" ? 1 : 0}</td>
                    <td>{e?.type_of_loan === "Installments" ? 1 : 0}</td>
                    <td>{e?.type_of_loan === "Pawn" ? 1 : 0}</td>
                  </>
                );
              })} */}

              {/* {row?.amount_and_type?.map((e) => {
                return e?.type_of_loan === "Installments" ? (
                  <td>{currencyFormat(e?.loan_amount)}</td>
                ) : (
                  <td></td>
                );
              })}
              {row?.amount_and_type?.map((e) => {
                return e?.type_of_loan === "Pawn" ? (
                  <td>{currencyFormat(e?.loan_amount)}</td>
                ) : (
                  <td></td>
                );
              })} */}
            </tr>
          ))}
        </table>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={3.5}>
          <div className="loan-footer-title">{`សៀមរាប ថ្ងៃទី${getKhmerNumber(
            moment().format("DD"),
          )} ខែ${getKhmerMonth(moment().format("M"))} ឆ្នាំ${getKhmerNumber(
            moment().format("YYYY"),
          )}`}</div>
          <div className="loan-footer-name">អ្នកទទួលប្រាក់</div>
          <div className="loan-footer-name" style={{ marginTop: "60px" }}>
            ........................
          </div>
        </Grid>

        <Grid item xs={2.5} sx={{ marginTop: "40px" }}>
          <div className="loan-footer-name">អ្នកបញ្ចេញប្រាក់</div>
          <div className="loan-footer-name" style={{ marginTop: "60px" }}>
            ........................
          </div>
        </Grid>

        <Grid item xs={6} sx={{ marginTop: "10px" }}>
          <div className="loan-footer-title">{khmerDateString}</div>
          <div className="loan-footer-title">{`សៀមរាប ថ្ងៃទី${getKhmerNumber(
            moment().format("DD"),
          )} ខែ${getKhmerMonth(moment().format("M"))} ឆ្នាំ${getKhmerNumber(
            moment().format("YYYY"),
          )}`}</div>

          <Stack direction="row" spacing={6}>
            <Box>
              <div className="loan-footer-name">អ្នកអនុម័ត</div>
              <div className="loan-footer-name" style={{ marginTop: "60px" }}>
                ........................
              </div>
            </Box>
            <Box>
              <div className="loan-footer-name">អ្នកធ្វើតារាង</div>
              <div className="loan-footer-name" style={{ marginTop: "60px" }}>
                ........................
              </div>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
}
